import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { IDiagnosticTroubleCode } from "@app/main/modules/maintenance/_components/faultCodes/_models/IDiagnosticTroubleCode";
import { ITimelineEntry } from "@directives/_veri/v-timeline/v-timeline.component";
import { IGoogleMapsMarkerOptions } from "@interfaces/IGoogleMapsMarkerOptions";
import { IVehicle } from "@interfaces/IVehicle";
import { GoogleMarkerService } from "@services/googleMarker.service";
import { PlotService } from "@services/plot.service";
import { ReeferMake } from "@temperature/_enums/reefer/ReeferMake.enum";
import { IReeferWithMappings } from "@temperature/_models/reefer/IReeferWithMappings";
import { IZoneWithProbes } from "@temperature/_models/temperature/ITemperatureZone";
import './zone-overview-page.component.scss';

@Component({
    selector: 'zone-overview-page',
    template: require('./zone-overview-page.component.html')
})
export class ZoneOverviewPageComponent implements OnInit {
    @Input() vehicle: IVehicle;
    @Input() zones: IZoneWithProbes[];

    @Input() diagnosticErrors: IDiagnosticTroubleCode[];
    @Input() timelineEntries: ITimelineEntry[] = [];
    @Input() reeferUnit: IReeferWithMappings;
    @Output() zoneSelected = new EventEmitter<number>();

    // ---

    ReeferMake = ReeferMake;
    reeferLocationMarker: IGoogleMapsMarkerOptions;

    constructor(private readonly plotService: PlotService, private readonly googleMarkerService: GoogleMarkerService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.vehicle && changes["vehicle"]) {
            this.createVehicleMarker();
        }
    }

    selectZone(id: number): void {
        this.zoneSelected.emit(id);
    }

    get fuelClass(): string {
        if (this.reeferUnit.fuelLevel < 15) {
            return 'error';
        }

        return 'ok';
    }

    // ---

    private createVehicleMarker(): void {
        this.plotService.getLatestPlotForVehicle(this.vehicle.Id).then(plot => {
            this.vehicle.Plot = plot;

            this.googleMarkerService.generateGoogleMapsMarkerOptionsForVehicle(this.vehicle).then(options => {

                this.reeferLocationMarker = options;
            });
        });
    }
}
